import { Watch, Route, Gauge, Zap, HeartPulse, Flame } from "lucide-react";

const METRICS = [
  { key: "distance_km", label: "km", name: "Distance", icon: Route },
  { key: "top_speed_kmh", label: "km/h", name: "Top speed", icon: Gauge },
  { key: "sprints", label: "", name: "Sprints", icon: Zap },
  { key: "avg_heart_rate", label: "bpm", name: "Avg HR", icon: HeartPulse },
  { key: "calories", label: "kcal", name: "Calories", icon: Flame },
];

function formatVal(v) {
  return Number.isInteger(v) ? v : v.toFixed(1);
}

export default function DeviceStatsStrip({ stats, postId }) {
  if (!stats) return null;
  const present = METRICS.filter((m) => stats[m.key] !== undefined && stats[m.key] !== null);
  if (present.length === 0) return null;

  return (
    <div
      data-testid={`post-device-stats-${postId}`}
      className="mx-4 mb-3 bg-[#0a0a0a] border border-[#262626] rounded-sm"
    >
      <div className="flex items-center gap-1.5 px-3 pt-2">
        <Watch className="w-3 h-3 text-[#737373]" />
        <span className="text-[9px] uppercase tracking-widest text-[#737373]">Tracker data</span>
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-1 px-3 pb-2.5 pt-1">
        {present.map((m) => {
          const Icon = m.icon;
          return (
            <div key={m.key} className="flex items-center gap-1.5" title={m.name}>
              <Icon className="w-3.5 h-3.5 text-[#a3a3a3]" />
              <span className="font-display text-base text-white leading-none">
                {formatVal(stats[m.key])}
              </span>
              {m.label && (
                <span className="text-[9px] uppercase tracking-widest text-[#737373]">{m.label}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
